import { DATA } from '../data'

var QQ = {
    initConfigShare() {
        var curPath = AppFate.$router.history.current.path,
            userInfo = AppFate.$store.state.userData,
            detailData = AppFate.$store.state.detail,
            commentData = AppFate.$store.state.comment,
            discussData = AppFate.$store.state.discuss,
            otherShareData = AppFate.$store.state.othershare,
            donateData = AppFate.$store.state.donate,
            famouspediaData = AppFate.$store.state.famouspedia;


        var baseTitle = '天时子平八字', hideName = false, newTitle = '', shareId = '',
            baseUrl = 'https://' + location.hostname + '/qq';
        var qqShareData = {
            title: baseTitle,
            desc: '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。',
            share_url: baseUrl,
            image_url: 'https://' + location.hostname + '/dist/logo.png',
        }
        
        // 处理record页面分享参数
        if (curPath == '/record') {
            qqShareData.share_url = baseUrl + '?path=record';
        }

        // 处理命盘分享参数
        if (curPath.indexOf('detail') != -1 && detailData.personInfo.birthday) {
            hideName = detailData.personInfo.f_name == '匿名' || detailData.hideName ? true : false;
            newTitle = DATA.getSharedTextByData('qq', hideName, detailData.personInfo);
            qqShareData.title = newTitle;
            qqShareData.desc = '点击可选择保存新八字。打开后点击右上角"..."选择"彩签"可锁定八字防刷屏.支持多八字对比';
            shareId = hideName ? detailData.personInfo.share : detailData.personInfo.share2;
            qqShareData.share_url = baseUrl + '?path=share-detail-' + shareId + '-save0';
        }
        // 处理批盘分享参数:自己的批盘
        if (curPath.indexOf('comment/detail') != -1 && detailData.personInfo.id) {
            qqShareData.title = DATA.getPipanSharedTextByData('qq', commentData.hideName, userInfo, detailData.personInfo);;
            qqShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
            shareId = commentData.hideName ? commentData.shareCode.nmpishare : commentData.shareCode.smpishare;
            qqShareData.share_url = baseUrl + '?path=share-comment-' + shareId;
            qqShareData.image_url = 'https://' + location.hostname + '/dist/share-img-2.png';
        }

        // 处理批盘分享参数:他人的批盘
        if(curPath.indexOf('comment/othercomment') != -1 && detailData.personInfo.id) {
            qqShareData.title = DATA.getOtherPipanShareTextByData('qq', commentData.hideName, commentData.otherShareTitle, detailData.personInfo);
            qqShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
            shareId = commentData.hideName ? commentData.otherShareCode.nmothershare : commentData.otherShareCode.smothershare;
            qqShareData.share_url = baseUrl + '?path=share-comment-' + shareId;
            qqShareData.image_url = 'https://' + location.hostname + '/dist/share-img-2.png';
        }

        // 处理批盘分享参数:二次转发分享页面
        if(curPath.indexOf('share/comment') != -1 && detailData.personInfo.id) {
            qqShareData.title = DATA.getOtherPipanShareTextByData('qq', commentData.hideName, otherShareData.shareTitle, detailData.personInfo);
            qqShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
            shareId = otherShareData.shareId;
            qqShareData.share_url = baseUrl + '?path=share-comment-' + otherShareData.shareId;
            qqShareData.image_url = 'https://' + location.hostname + '/dist/share-img-2.png';
        }

        // 处理论盘分享参数
        if(curPath.indexOf('discuss/') != -1 && detailData.personInfo.id) {
            qqShareData.title = DATA.getLunPanShareTextByData('qq', discussData.lunpanData.title, detailData.personInfo);
            qqShareData.desc = '点击进入在线论盘，论盘记录将永久保存在对应八字下面的论盘记录中，可随时查阅。';
            shareId = discussData.hideName ? discussData.lunpanData.shareCode.nmlpshare : discussData.lunpanData.shareCode.smlpshare;
            qqShareData.share_url = baseUrl + '?path=share-discuss-' + shareId;
            qqShareData.image_url = 'https://' + location.hostname + '/dist/share-img-3.png';
        }

        // 处理捐赠页面分享参数
        if(curPath.indexOf('donate') != -1) {
            var donateTitle = donateData && donateData.myNum && donateData.myNum != 0 ? 
                ('助力传统文化复兴，我是第' + donateData.myNum + '位文化复兴大使！') :
                '助力传统文化复兴，我来点燃星火！';
            qqShareData.title = donateTitle;
            qqShareData.desc = '文化复兴，功在当代，利在千秋。';
            qqShareData.share_url = baseUrl + '?path=donate';
            qqShareData.image_url = 'https://' + location.hostname + '/dist/share-img-4.png';
        }

        // 处理异常情况:恢复成默认的情况
        if(!shareId){
            qqShareData.title = baseTitle;
            qqShareData.desc = '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。';
            qqShareData.share_url = baseUrl;
            qqShareData.image_url = 'https://' + location.hostname + '/dist/logo.png';
        }

        // 处理百科页面分享参数
        if(curPath.indexOf('famouspedia') != -1) {
            var famousTitle = '名人八字百科',
                famousUrl = baseUrl + '?path=famouspedia';
            if(curPath.indexOf('/famouspediaread') != -1) {
                var famousBaziInfo = famouspediaData.curPediaBaziInfo;
                famousTitle = famousBaziInfo ? DATA.getFamousPediaShareTextByData('qq', famousBaziInfo) : famousTitle;
                famousUrl = famousBaziInfo ? baseUrl + '?path=share-famouspediaread-' + famousBaziInfo.id + '-famouspedia' : famousUrl;
            }
            qqShareData.title = famousTitle;
            qqShareData.desc = '点击可查看名人生平事迹及与之对应的各位易友的论断。';
            qqShareData.share_url = famousUrl;
            qqShareData.image_url = 'https://' + location.hostname + '/dist/share-img-5.png';
        }

        console.log('initConfigShare-----', curPath, qqShareData)
        if(mqq && mqq.data) {
            mqq.data.setShareInfo(qqShareData);
        }
    }
}

export {
    QQ
}
